import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { DashboardView } from "@/components/dashboard/dashboard-view";
import { getDashboardStats } from "@/lib/dashboard";

const routeApi = getRouteApi("/admin/");

const Dashboard = () => <DashboardView stats={routeApi.useLoaderData()} />;

export const Route = createFileRoute("/admin/")({
  component: Dashboard,
  loader: () => getDashboardStats(),
});
